export const formatObject = (object, cartId) => {
    return {
        "id": cartId,
        "barcode": object?.ean[0],
        "description": object?.description,
    }
};